import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, doc, getDoc } from "firebase/firestore";
import { firestore } from "../firebase-config";
import { id_firebase } from "../content-site";
import { FaWhatsapp } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { retiraMascara } from "../utils/retiraMascara";
import { formatCambio } from "../utils/formatCambio";
import { formatMoney } from "../utils/formatMoney";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function VeiculoClient() {
    const { idVeiculo } = useParams();
    const [veiculos, setVeiculos] = useState({});
    const [revenda, setRevenda] = useState({});
    const [nome, setNome] = useState('');
    const [telefone, setTelefone] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [enviado, setEnviado] = useState(false);
    const [msgEnviado, setMsgEnviado] = useState('');
    const [,setErrors] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);

        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setRevenda(docSnap.data());
            }
        });

        const veiculoRef = doc(
            collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
            idVeiculo
        );
        getDoc(veiculoRef).then((docSnap) => {
            if (docSnap.exists()) {
                setVeiculos({ ...docSnap.data(), id: docSnap.id });
            }
        });
    }, [idVeiculo]);

    const validateForm = () => {
        const newErrors = {};
        if (!nome.trim()) newErrors.nome = "Nome obrigatório.";
        if (!mensagem.trim()) newErrors.mensagem = "Mensagem obrigatória.";
        if (!telefone.trim()) newErrors.telefone = "Telefone obrigatório.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!validateForm()) return;
        setEnviado(true);
        setMsgEnviado('Enviando mensagem...');

        let corpoMensagem = `<strong>Mensagem:</strong>`;
        corpoMensagem += `<br><br><strong>Dados pessoais</strong><br>`;
        corpoMensagem += `<br>Nome: ${nome}`;
        corpoMensagem += `<br>Telefone: ${retiraMascara(telefone)}`;
        corpoMensagem += `<br>Mensagem: ${mensagem}`;

        fetch('https://us-central1-intermedio-1513801146022.cloudfunctions.net/enviarEmail', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                remetente: `Contato ${revenda.penome_fantasia}<${revenda.peemail}>`,
                assunto: `Interesse no veiculo ${veiculos.vefipe_marca} - ${veiculos.vefipe_name} // Site ${revenda.penome_fantasia}`,
                destinatarios: revenda.peemail,
                corpo: corpoMensagem,
                corpoHtml: corpoMensagem,
            }),
        })
            .then(() => {
                setMsgEnviado('E-mail enviado com sucesso! Em breve você receberá um retorno da nossa equipe.');
                setTimeout(() => setEnviado(false), 5000);
                resetForm();
            })
            .catch((error) => {
                setMsgEnviado('Erro ao enviar e-mail, tente novamente mais tarde.');
                setTimeout(() => setEnviado(false), 5000);
                console.error('Erro ao enviar e-mail:', error);
            });
    };

    const resetForm = () => {
        setNome('');
        setTelefone('');
        setMensagem('');
        setErrors({});
    };

    if (!veiculos) return <div className="text-center py-20">Carregando veículo...</div>;

    return (
        <div>
            <Header />
            <div className="max-w-6xl mx-auto px-2 sm:px-4 py-8 mt-20 grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="col-span-1 lg:col-span-2 flex flex-col gap-8">
                    <div className="rounded-xl overflow-hidden shadow-lg">
                        <div className="relative">
                            <Swiper
                                spaceBetween={10}
                                slidesPerView={1}
                                modules={[Navigation]}
                                navigation={{
                                    nextEl: ".swiper-button-next-custom",
                                    prevEl: ".swiper-button-prev-custom",
                                }}
                                className="group"
                            >
                                {Array.isArray(veiculos.imagens) && veiculos.imagens.length > 0 &&
                                    veiculos.imagens.map((img, index) => (
                                        <SwiperSlide key={index}>
                                            <img
                                                src={img.fileUrl}
                                                alt={`Foto ${index + 1} do veículo`}
                                                className="w-full h-[350px] sm:h-[350px] md:h-[400px] object-cover"
                                            />
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>

                            <button
                                className="swiper-button-prev-custom flex absolute top-1/2 left-2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white text-blue-900 rounded-full p-2 shadow transition lg:hidden"
                                aria-label="Foto anterior"
                            >
                                <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <button
                                className="swiper-button-next-custom flex absolute top-1/2 right-2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white text-blue-900 rounded-full p-2 shadow transition lg:hidden"
                                aria-label="Próxima foto"
                            >
                                <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>

                            {/* Setas para desktop */}
                            <button
                                className="swiper-button-prev-custom hidden lg:flex absolute top-1/2 left-2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white text-blue-900 rounded-full p-2 shadow transition"
                                aria-label="Foto anterior"
                            >
                                <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <button
                                className="swiper-button-next-custom hidden lg:flex absolute top-1/2 right-2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white text-blue-900 rounded-full p-2 shadow transition"
                                aria-label="Próxima foto"
                            >
                                <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Informações do veículo - só acima do formulário no mobile */}
                    <div className="block lg:hidden order-1">
                        <h1 className="text-2xl font-bold text-blue-900 mb-2">{veiculos.vefipe_marca} - {veiculos.vefipe_name}</h1>
                        <p className="text-4xl text-red-600 font-bold mb-6 bg-red-200 w-fit px-4 py-2 rounded-lg shadow-md">
                            {formatMoney(veiculos.vevalor)?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                        </p>
                        <ul className="grid grid-cols-2 gap-4 text-sm text-gray-700 mb-6">
                            <li><strong>Ano:</strong> {veiculos.vefipe_ano_modelo}</li>
                            <li><strong>Cor:</strong> {veiculos.vecor}</li>
                            <li><strong>Câmbio:</strong> {formatCambio(veiculos.vecambio)}</li>
                            <li><strong>Combustível:</strong> {veiculos.vefipe_combustivel}</li>
                            <li><strong>KM:</strong> {veiculos.vequilometragem}km</li>
                        </ul>
                        <div className="mb-6">
                            <h3 className="text-blue-900 font-semibold mb-2">Opcionais:</h3>
                            <ul className="flex flex-wrap gap-2 text-sm text-gray-700">
                                {veiculos.opcionais?.map((item, idx) => (
                                    <li key={idx} className="bg-blue-50 text-blue-800 px-3 py-1 rounded-full shadow-sm">
                                        {typeof item === "object" ? item.descricao : item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Formulário de contato */}
                    <div className="bg-gray-50 rounded-xl p-4 sm:p-6 shadow-md w-full max-w-xl ml-0 lg:ml-[-1rem] xl:ml-[-1.5rem] order-2">
                        <h3 className="text-lg font-bold text-blue-900 mb-4">Entre em contato</h3>
                        <form className="space-y-3" onSubmit={handleSubmit}>
                            <input
                                type="text"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                placeholder="Seu nome"
                                className="w-full p-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-600 outline-none"
                            />
                            <input
                                type="tel"
                                value={telefone}
                                onChange={(e) => setTelefone(e.target.value)}
                                placeholder="Telefone"
                                className="w-full p-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-600 outline-none"
                            />
                            <textarea
                                placeholder="Mensagem"
                                value={mensagem}
                                onChange={(e) => setMensagem(e.target.value)}
                                className="w-full p-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-600 outline-none"
                                rows={4}
                            ></textarea>
                            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8">
                                <button
                                    type="submit"
                                    className="bg-blue-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-800 transition w-full sm:w-auto"
                                >
                                    Enviar Mensagem
                                </button>
                                <a
                                    href={`https://api.whatsapp.com/send?phone=55${retiraMascara(revenda.petelefone2, "link")}&text=${encodeURIComponent(`Olá, tenho interesse no ${veiculos.vefipe_marca} - ${veiculos.vefipe_name}`)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 bg-green-600 text-white font-medium hover:underline border-2 border-green0800 hover:bg-green-700 px-6 py-3 rounded-lg transition w-full sm:w-auto justify-center"
                                >
                                    <FaWhatsapp className="text-xl" /> Falar via WhatsApp
                                </a>
                            </div>
                            {msgEnviado && (
                                <div className={`mb-4 text-center font-semibold ${enviado ? 'text-blue-700' : 'text-red-600'}`}>
                                    {msgEnviado}
                                </div>
                            )}
                        </form>
                    </div>
                </div>

                {/* Detalhes do veículo - apenas para desktop */}
                <div className="hidden lg:block col-span-1">
                    <h1 className="text-2xl font-bold text-blue-900 mb-2">{veiculos.vefipe_marca} - {veiculos.vefipe_name}</h1>
                    <p className="text-4xl text-red-600 font-bold mb-6 bg-red-200 w-fit px-4 py-2 rounded-lg shadow-md">
                        {formatMoney(veiculos.vevalor)?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                    </p>
                    <ul className="grid grid-cols-2 gap-4 text-sm text-gray-700 mb-6">
                        <li><strong>Ano:</strong> {veiculos.vefipe_ano_modelo}</li>
                        <li><strong>Cor:</strong> {veiculos.vecor}</li>
                        <li><strong>Câmbio:</strong> {formatCambio(veiculos.vecambio)}</li>
                        <li><strong>Combustível:</strong> {veiculos.vefipe_combustivel}</li>
                        <li><strong>KM:</strong> {veiculos.vequilometragem}km</li>
                    </ul>
                    <div className="mb-6">
                        <h3 className="text-blue-900 font-semibold mb-2">Opcionais:</h3>
                        <ul className="flex flex-wrap gap-2 text-sm text-gray-700">
                            {veiculos.opcionais?.map((item, idx) => (
                                <li key={idx} className="bg-blue-50 text-blue-800 px-3 py-1 rounded-full shadow-sm">
                                    {typeof item === "object" ? item.descricao : item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <Footer />
        </div>

    )
}